import { render, staticRenderFns } from "./AccertamentiSupplementariDettagliView.vue?vue&type=template&id=35973b59"
import script from "./AccertamentiSupplementariDettagliView.vue?vue&type=script&lang=js"
export * from "./AccertamentiSupplementariDettagliView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports